const safeAreaValues = {
  bottom: 'var(--safe-area-inset-bottom, env(safe-area-inset-bottom, 0px))',
  left: 'var(--safe-area-inset-left, env(safe-area-inset-left, 0px))',
  right: 'var(--safe-area-inset-right, env(safe-area-inset-right, 0px))',
  top: 'var(--safe-area-inset-top, env(safe-area-inset-top, 0px))'
};

export const safeArea = safeAreaValues;
